import * as React from 'react';
import styled from 'styled-components';

import NoteIcon from '../../../shared/components/icons/NoteIcon';
import t from '../../../shared/translations';
import {
    ShareAnswersType
} from '../../../shared/types';
import { useCurrentPerson } from '../../components/CurrentPerson';
import { Box } from '../stylings';

interface IProps {
    shareType: ShareAnswersType;
    anonymous: boolean;
}

const H3 = styled.h3`
    display: flex;
    align-items: center;
    svg {
        width: 26px;
        height: 26px;
        flex-shrink: 0;
    }
`;

function ShareAnswersInfo({ shareType, anonymous }: IProps): JSX.Element {
    const pathname = useCurrentPerson().currentPath?.pathname;
    if (shareType === 'no_one') {
        return null;
    }
    return <Box>
        <H3>
            <NoteIcon />
            {t('player.task.heading-share-answers')}
        </H3>
        {shareType === 'group' && <p>{t('player.task.info-share-answers-group')}</p>}
        {shareType === 'path' && <p>{t('player.task.info-share-answers-path', { pathname })}</p>}
        <p>{t('player.task.info-share-answers-see-answers-after-submit')}</p>
        <p><strong>{anonymous
            ? t('player.task.info-share-answers-anonymous')
            : t('player.task.info-share-answers-not-anonymous')
        }</strong></p>
    </Box>;
}

export default ShareAnswersInfo;
